import { render, staticRenderFns } from "./tenderWarning.vue?vue&type=template&id=1320de3b&scoped=true"
import script from "./tenderWarning.vue?vue&type=script&lang=js"
export * from "./tenderWarning.vue?vue&type=script&lang=js"
import style0 from "./tenderWarning.vue?vue&type=style&index=0&id=1320de3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320de3b",
  null
  
)

export default component.exports